<template>
	<div class="mega-menu">
		<v-menu
			v-if="isDesktop"
			v-model="isMenuOpen"
			:open-delay="0"
			:close-delay="20"
			content-class="mega-menu-overlay"
			location="bottom"
			:disabled="menuDisabled"
			:close-on-content-click="false"
			scroll-strategy="close"
			transition="scroll-y-transition"
			:offset="72"
			open-on-hover
			:z-index="2051">
			<template #activator="{ props }">
				<button v-bind="props" class="nav__item nav__item--dropdown">
					<span>{{ $t(`components.nav.${item.translation_key_label}`) }}</span>
					<GlobalIcon
						name="arrow-down"
						:height="18"
						class="mega-menu__icon"
						:class="{ 'mega-menu__icon--expanded': props['aria-expanded'] === 'true' }" />
				</button>
			</template>
			<Transition name="menu-fade">
				<div v-if="isMenuOpen" class="mega-menu-overlay__dropdown" @mouseleave="isMenuOpen = false">
					<div class="mega-menu-overlay__menus">
						<div class="mega-menu-overlay__menu mega-menu-overlay__menu--first">
							<template v-for="(section, l) in computedMenu" :key="l">
								<div v-if="l !== 0" class="mega-menu-overlay__divider"></div>
								<div class="mega-menu-overlay__menu-title">
									{{ i18nService.$tDynamic('components.nav.mega_menu', section.translation_key_title || section.title) }}
									<!-- {{$t('components.nav.mega_menu.car_rental_lublin_airport')}} -->
								</div>
								<div class="mega-menu-overlay__menu-links mega-menu-overlay__menu-links--main">
									<div v-for="(menuItem, j) in computedMenu[l].items" :key="j" class="mega-menu-overlay__menu-link-container">
										<ButtonCustom
											:to="menuItem?.link === 'electric-cars' ? pathForElectric : localePath(menuItem?.link) || undefined"
											class="mega-menu-overlay__menu-link"
											@mouseover="updateLastHoveredCategory(menuItem)"
											@click="onMenuItemClick(menuItem)">
											<GlobalIcon
												v-if="menuItem.icon"
												:name="menuItem.icon"
												:height="18"
												:width="18"
												color="var(--primary-color)"
												class="mega-menu-overlay__menu-link-main-icon" />
											<div class="mega-menu-overlay__menu-link-info">
												<div class="mega-menu-overlay__menu-link-text">
													{{
														i18nService.$tDynamic(
															'components.nav.mega_menu',
															menuItem.translation_key_title || menuItem.title,
														)
													}}
												</div>
												<div
													v-if="menuItem.subText || menuItem.translation_key_subText"
													class="mega-menu-overlay__menu-link-subtext">
													{{
														i18nService.$tDynamic(
															'components.nav.mega_menu',
															menuItem.translation_key_subText || menuItem.subText,
														)
													}}
												</div>
											</div>
											<GlobalIcon
												v-if="menuItem.menu || (menuItem.items && menuItem.items.length > 0)"
												name="arrow-down"
												:height="14"
												:width="12"
												class="mega-menu-overlay__menu-link-icon" />
										</ButtonCustom>
									</div>
								</div>
							</template>
						</div>
						<Transition name="menu-fade-x" mode="out-in">
							<div v-if="lastHoveredCategory" class="mega-menu-overlay__submenu">
								<div
									v-if="lastHoveredCategory?.items || lastHoveredCategory?.menu"
									class="mega-menu-overlay__submenu-links mega-menu-overlay__submenu-links--main">
									<div
										v-for="(subItem, j) in lastHoveredCategory?.items"
										:key="j"
										class="mega-menu-overlay__submenu-link-container">
										<ButtonCustom
											:to="localePath(subItem?.link) || undefined"
											class="mega-menu-overlay__submenu-link"
											@click="onSubItemClick(lastHoveredCategory, subItem)">
											<span>
												{{
													i18nService.$tDynamic('components.nav.mega_menu', subItem.translation_key_title || subItem.title)
												}}</span
											>
										</ButtonCustom>
									</div>
									<template v-if="areCustomItems(lastHoveredCategory.translation_key_title)">
										<div
											v-for="subItem in customItems"
											:key="subItem.translation_key_title"
											class="mega-menu-overlay__submenu-link-container">
											<ButtonCustom :to="subItem?.to || undefined" class="mega-menu-overlay__submenu-link">
												<span>
													{{
														i18nService.$tDynamic(
															'components.nav.mega_menu',
															subItem.translation_key_title || subItem.title,
														)
													}}
												</span>
											</ButtonCustom>
										</div>
									</template>
								</div>
								<!-- <div
									v-else-if="lastHoveredCategory?.menu"
									class="mega-menu-overlay__submenu-links mega-menu-overlay__submenu-links--center">
									<GlobalMegaMenuCheckOffer />
								</div> -->
							</div>
						</Transition>
					</div>
					<div class="mega-menu-overlay__swiper">
						<Swiper
							:modules="[Scrollbar, Navigation]"
							:navigation="true"
							:scrollbar="{
								hide: false,
							}"
							class="mega-menu__swiper"
							:class="{ 'mega-menu__swiper--loading': !cars || cars.length < 1 || megaMenuStore.getAreCarsLoading }"
							slidesPerView="auto"
							:space-between="16"
							@swiper="setSwiper">
							<SwiperSlide
								v-for="(car, j) in cars"
								v-show="cars && cars.length && !megaMenuStore.getAreCarsLoading"
								:key="j"
								class="mega-menu__swiper-slide">
								<CarsSingleCar :car="car" home @click="isMenuOpen = false" @closeMegaMenu="isMenuOpen = false" />
							</SwiperSlide>
							<SwiperSlide
								v-for="k in 10"
								v-show="!cars || cars.length < 1 || megaMenuStore.getAreCarsLoading"
								:key="k"
								:slidesPerView="4"
								:space-between="16"
								class="mega-menu__swiper-slide">
								<Skeletor class="mega-menu__skeletor" round :height="497" />
							</SwiperSlide>
						</Swiper>
					</div>
				</div>
			</Transition>
		</v-menu>
	</div>
</template>

<script setup lang="ts">
import { Scrollbar, Navigation } from 'swiper/modules'
import { Skeletor } from 'vue-skeletor'
import {
	busesIDs,
	deliveryBusesIDs,
	airportsIDs,
	branchesIDs,
	busesIDsEN,
	deliveryBusesIDsEN,
	airportsIDsEN,
	branchesIDsEN,
	megaMenuData,
	megaMenuDataEN,
} from '@/data/megaMenuData'
import 'swiper/css/scrollbar'

const localePath = useLocalePath()
const { isDesktop } = useWindowWidth()
const lastHoveredCategory = ref<any>(null)
const swiperRef = ref<any>(null)
const groups = ref<IProductGroupModel[]>([])
const cars = ref<IProductModel[]>([])
const carsStore = useCarsStore()
const megaMenuStore = useMegaMenuStore()
const hoveredGroup = ref<string | undefined>()
const menuDisabled = ref(false)
const i18nService = usei18nService()
const carRentalStore = useCarRentalStore()
const CMSLocationsStore = useCMSLocationsStore()
const CMSLocations = ref<ICMSLocationModel[] | undefined>(undefined)
const { locale } = useI18n()
const $t = useI18n().t

const computedMenu = computed(() => {
	return locale.value === 'pl' ? megaMenuData : megaMenuDataEN
})

const pathForElectric = computed(() => {
	return localePath({ name: 'car-rental-urlSlug', params: { urlSlug: locale.value === 'pl' ? 'elektrycznych' : 'electric' } })
	// return '/pl/wypozyczalnia-samochodow-elektrycznych'
})

const areCustomItems = (key: string) => {
	return key === 'bus_rental' || key === 'cities' || key === 'airports' || key === 'delivery_van_rental'
}

const customItems = computed(() => {
	if (!lastHoveredCategory.value) return []

	if (lastHoveredCategory.value.translation_key_title === 'bus_rental') return busesData.value
	if (lastHoveredCategory.value.translation_key_title === 'delivery_van_rental') return deliveryBusesData.value
	if (lastHoveredCategory.value.translation_key_title === 'cities') return branchesData.value
	if (lastHoveredCategory.value.translation_key_title === 'airports') return airportsData.value
	return []
})

watch(
	() => CMSLocationsStore.getCMSLocations,
	(newValue) => {
		if (newValue) {
			CMSLocations.value = newValue
		}
	},
	{
		immediate: true,
		deep: true,
	},
)

const sortCustomMenuItems = (
	itemsToSort: ICMSLocationModel[],
	placesIDsArray: {
		id: string
		translation_key_title: string
	}[],
) => {
	const sortedItems = placesIDsArray.map((place) => {
		const foundItem = itemsToSort.find((item) => item.placeId === place.id)
		return { ...foundItem, translation_key_title: place.translation_key_title }
	})

	if (!sortedItems || sortedItems.length === 0) return []

	const formattedItems = sortedItems?.map((item) => ({
		to: getURLforLocation(item),
		translation_key_title: item.translation_key_title,
	}))

	formattedItems.push({
		to: localePath('locations'),
		translation_key_title: 'see_all_locations',
	})
	return formattedItems
}

const getURLforLocation = (item: ICMSLocationModel & { translation_key_title: string }) => {
	const urlLocale = item[`isActive${locale.value.toUpperCase()}`] ? item[`url${locale.value.toUpperCase()}`] : undefined
	const url = item.urlPL

	if (!url && !urlLocale) return undefined
	else
		return urlLocale
			? localePath({ name: 'car-rental-urlSlug', params: { urlSlug: urlLocale } }, locale.value)
			: localePath({ name: 'car-rental-urlSlug', params: { urlSlug: url } }, 'pl')
}

const busesData = computed(() => {
	const buses = CMSLocations.value?.filter(
		(l) =>
			(l.icon === 'location-bold' || (l.icon !== 'location-bold' && l.icon !== 'airplane')) &&
			l.showInMenu &&
			l.isActivePL &&
			!l.urlPL.includes('dostawczy'),
	)
	if (!buses || buses.length === 0) return []
	const busesIDsTemp = locale.value === 'pl' ? busesIDs : busesIDsEN
	return sortCustomMenuItems(buses, busesIDsTemp)
})

const deliveryBusesData = computed(() => {
	const deliveryBuses = CMSLocations.value?.filter(
		(l) => (l.icon === 'location-bold' || (l.icon !== 'location-bold' && l.icon !== 'airplane')) && l.showInMenu && l.isActivePL,
	)
	if (!deliveryBuses || deliveryBuses.length === 0) return []
	const deliveryBusesIDsTemp = locale.value === 'pl' ? deliveryBusesIDs : deliveryBusesIDsEN
	return sortCustomMenuItems(deliveryBuses, deliveryBusesIDsTemp)
})

const airportsData = computed(() => {
	const airports = CMSLocations.value?.filter((l) => l.icon === 'airplane' && l.showInMenu && l.isActivePL)
	if (!airports || airports.length === 0) return []
	const airportsIDsTemp = locale.value === 'pl' ? airportsIDs : airportsIDsEN
	return sortCustomMenuItems(airports, airportsIDsTemp)
})

const branchesData = computed(() => {
	const branches = CMSLocations.value?.filter((l) => l.icon !== 'airplane' && l.showInMenu && l.isActivePL)
	if (!branches || branches.length === 0) return []
	const branchesIDsTemp = locale.value === 'pl' ? branchesIDs : branchesIDsEN
	return sortCustomMenuItems(branches, branchesIDsTemp)
})

const isMenuOpen = ref(false)
provide('isMenuOpen', isMenuOpen)

const sendAnalyticsData = (item: any, subItem?: any) => {
	const gtmService = useGTMService()
	if (!gtmService) return

	const mainItem = { ...item, ...(subItem || {}) }

	const GTMParameters = {
		section: 'navigation',
		element: 'navigation-link',
		element_value: mainItem?.link,
		// by city
		location: mainItem.location,
		// by length of rental
		rental_length: mainItem.rental_length,
		// by car category
		category: mainItem.category,
	}
	gtmService.offerInterest(GTMParameters)
}

const onSubItemClick = (item: any, subItem: any) => {
	switch (subItem.link) {
		case '2months':
			carRentalStore.setRangeValue(2)
			break
		case '3months':
			carRentalStore.setRangeValue(3)
			break
		case '6months':
			carRentalStore.setRangeValue(6)
			break
		default:
			carRentalStore.setRangeValue(1)
			break
	}
	isMenuOpen.value = false
	sendAnalyticsData(item, subItem)
}

const onMenuItemClick = (item: any) => {
	carRentalStore.setRangeValue(1)
	isMenuOpen.value = false
	sendAnalyticsData(item)
}

const fetchGroups = async () => {
	try {
		const response = await carsStore.fetchAllGroups()
		groups.value = response
		return response
	} catch (error) {
		console.error(error)
	}
}

// onMounted(() => {
// 	fetchGroups()
// })

const fetchCars = async (group?: string) => {
	cars.value = []
	if (!groups.value.length) await fetchGroups()
	const fetchedCars = await megaMenuStore.fetchCarsWithFilters(groups.value, group ? [group] : undefined)
	if (fetchedCars.response) cars.value = fetchedCars.response
	else cars.value = fetchedCars
}

defineProps<{
	item: {
		translation_key_label: string
		to: string
		type: string
	}
}>()

const updateLastHoveredCategory = async (category: any) => {
	if (category?.translation_key_title === lastHoveredCategory.value?.translation_key_title) return

	if (category?.filters && hoveredGroup.value !== category.filters[0]) {
		hoveredGroup.value = category.filters[0]
	} else if (!category?.filters && hoveredGroup.value) {
		hoveredGroup.value = undefined
	}

	if ((!category.items || category.items.length === 0) && !category.menu) {
		clearLastHoveredCategory()
		return
	}

	await nextTick()
	if (lastHoveredCategory.value) {
		lastHoveredCategory.value = null
	}
	setTimeout(() => {
		lastHoveredCategory.value = category
	}, 100)
}

const clearLastHoveredCategory = async () => {
	if (!lastHoveredCategory.value) return
	await nextTick()
	setTimeout(() => {
		lastHoveredCategory.value = null
	}, 100)
}

watch(
	() => isMenuOpen.value,
	(newValue) => {
		if (!newValue) {
			menuDisabled.value = true
			setTimeout(() => {
				menuDisabled.value = false
			}, 300)
		}
	},
)

watch(
	() => hoveredGroup.value,
	() => {
		fetchCars(hoveredGroup.value)
		swiperRef.value.activeIndex = 0
	},
)

watch(
	() => isMenuOpen.value,
	async (isOpen) => {
		if (!isOpen) {
			clearLastHoveredCategory()
			hoveredGroup.value = undefined
		} else {
			fetchCars(hoveredGroup.value)
			if (!CMSLocations.value?.length) {
				CMSLocations.value = await CMSLocationsStore.fetchCMSLocations()
			}
		}
	},
)

const setSwiper = (swiper: any) => {
	swiperRef.value = swiper
}
</script>

<style lang="scss">
@import 'vue-skeletor/dist/vue-skeletor.css';
@import './MegaMenu.scss';

.menu-fade-enter-active {
	transition: all 0.1s ease-out;
}

.menu-fade-leave-active {
	transition: all 0.1s ease-in;
}

.menu-fade-enter-from,
.menu-fade-leave-to {
	transform: translateY(-20px);
	opacity: 0;
}

.menu-fade-x-enter-active {
	transition: all 0.1s ease-out;
}

.menu-fade-x-leave-active {
	transition: all 0.1s ease-in;
}

.menu-fade-x-enter-from,
.menu-fade-x-leave-to {
	transform: translateX(-20px);
	opacity: 0;
}
</style>
